module.exports = __webpack_public_path__ + "static/media/auto-flash.74de9b2b.svg";